module.exports = __webpack_public_path__ + "static/media/Game1.93aa4bb4.svg";